module.exports = __webpack_public_path__ + "img/accords-hybridandsedan-21.e74fb530.png";